import { render, staticRenderFns } from "./LegalAndTaxPanel.vue?vue&type=template&id=d2c5e066&"
import script from "./LegalAndTaxPanel.vue?vue&type=script&lang=ts&"
export * from "./LegalAndTaxPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LegalAndTaxPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports